module.exports = __webpack_public_path__ + "img/tree-04-g-trunk.6058f1f6.png";